import 'quill/dist/quill.snow.css';
import 'react-datepicker/dist/react-datepicker.css';
import tippy from 'tippy.js';
import 'tippy.js/animations/shift-toward.css';
import 'tippy.js/dist/tippy.css';
import { copyToClipboard } from 'shared/clipboard';
import {
  error,
  errorMessage,
  success,
  successMessage,
  warning,
  warningMessage,
} from 'shared/toast';
import '../amplemarket_hook';
import '../other_crm_integration';
import '../shared/config/opentelemetry/opentelemetry.init';
import '../shared/config/sentry/sentry.init';
import '../toasts';
import '../zendesk_sell_lead_card';
import '../zendesk_sell_resize';

// Make globally available in rails views
window.copyToClipboard = copyToClipboard;
window.toast = {
  success,
  error,
  warning,
  successMessage,
  errorMessage,
  warningMessage,
};

window.tippy = tippy;
